import API_URL from '../apiConfig';

class User {
  static instance = new User("");
  token;
  email;
  name;
  phone;
  address;
  role;
  profilePic;

  constructor(token) {
    this.token = token;
  }

  setData(data) {
    if (data.name) this.name = data.name;
    if (data.email) this.email = data.email;
    if (data.phone) this.phone = data.phone;
    if (data.address) this.address = data.address;
    if (data.role) this.role = data.role;
    if (data.profilePic) this.profilePic = data.profilePic;
  }

  setToken(token) {
    this.token = token;
    localStorage.setItem("token", token);
  }

  getToken() {
    this.token = localStorage.getItem("token");
    return this.token
  }

  async fetchData() {
    if (!this.getToken()) return;
    const response = await fetch(`${API_URL}/api/auth/user`, {
      headers: {
        Authorization: `Bearer ${this.getToken()}`,
      },
    });
    const data = await response.json();
    this.setData(data);
  }

  async changePassword(oldPassword, newPassword) {
    const response = await fetch(`${API_URL}/api/auth/changepassword`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ 'newPassword': newPassword, 'oldPassword': oldPassword }),
    });

    const data = await response.json();
    return { success: response.ok, message: data.message };
  }

  async updateData(data) {
    this.name = data.name;
    this.phone = data.phone;
    this.address = data.address;
    if (data.profilePic !== undefined) this.profilePic = data.profilePic;

    const response = await fetch(`${API_URL}/api/auth/user`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: this.name,
        phone: this.phone,
        address: this.address,
        profilePic: this.profilePic
      }),
    });

    return response.status < 400;
  }

  async signOut() {
    this.token = ""
    localStorage.removeItem("token")
    this.email = ""
    this.name = ""
    this.phone = ""
    this.address = ""
    this.role = ""
    this.profilePic = ""
  }
}

export default User;